module.exports = __webpack_public_path__ + "static/logo-new2-342d430b1bc04fa4c72eb60dda2f92da.png";